<!-- START: App Update Banner -->
@if (updateAvailable()) {
  <aside class="update-banner flex-row justify-center align-center gap-16" role="status" aria-live="polite">
    <!-- Update message -->
    <span class="update-banner__message">A new version of the application is available.</span>
    <!-- Refresh action -->
    <fsx-button
      [label]="'Refresh'"
      [buttonType]="FsxButtonTypeEnum.Primary"
      (onClickedEvent)="onRefreshClicked()"
    ></fsx-button>
  </aside>
}
<!-- END: App Update Banner -->
